uniform float uTime;

uniform sampler2D uPerlinTexture;
uniform float uPortalOpening;
uniform vec3 uPortalColor;
uniform float uRipples;
uniform float uRippleSpeed;
uniform float uPerlinBlend;
uniform float uPerlinMultiply;

varying vec2 vUv;

void main()
{
    vec2 perlinUv1 = vUv;
    perlinUv1.x += 0.05 * uTime;
    perlinUv1.y += 0.05 * uTime;
    perlinUv1 *= 2.1;
    vec4 perlin1 = texture(uPerlinTexture, perlinUv1);

    vec2 perlinUv2 = vUv;
    perlinUv2 *= -1.7;
    perlinUv2.x += 0.05 * uTime;
    perlinUv2.y += 0.05 * uTime;
    vec4 perlin2 = texture(uPerlinTexture, perlinUv2);

    perlin1 *= uPerlinBlend * perlin2;
    
    float distanceFromCenter = distance(vUv, vec2(0.5));
    float outerGlow = smoothstep(0.0, 1.0, distanceFromCenter) + (cos(uPortalOpening) + 0.59);
    float strength = 1.0;


    strength *= 2.0 + cos(uRipples * distanceFromCenter + (uRippleSpeed * uTime));
    strength *= distance(perlin1, perlin2);

    gl_FragColor = vec4(vec3(strength) * uPortalColor, outerGlow);
    // gl_FragColor = vec4(0.0, 0.0, 1.0, 1.0);

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}